import { isSSR } from 'oasis-os-utils';
// Loaded features will be noted for serialization
// This helps us preload features before hydration
const PRELOAD_FEATURES = {};
/**
 * Storage for caching feature apps before hydration starts
 */
const PRELOAD_CACHE = new Map();
function getCachedKey(lib, mod) {
    return `${lib}-${mod}`;
}
export function getCachedModule(lib, mod) {
    const key = getCachedKey(lib, mod);
    if (PRELOAD_CACHE.has(key)) {
        return PRELOAD_CACHE.get(key);
    }
}
function cacheModule(lib, modName, mod) {
    const key = getCachedKey(lib, modName);
    PRELOAD_CACHE.set(key, mod?.default || mod);
}
export function loadFeatureApp(scope, mod, hydration = false) {
    return async () => {
        // Initializes the share scope. This fills it with known provided modules from this build and all remotes
        await __webpack_init_sharing__('default');
        // Get MF container
        const container = window[scope];
        if (!container) {
            // todo: custom error types and attempt fallback
            console.error(`Feature App %c ${scope} `, 'background-color: #ff3333; color: #ccffff;', `could not be loaded.`);
            return;
        }
        // Initialize the container, it may provide shared modules
        await container.init(__webpack_share_scopes__.default);
        // Get shared module
        const factory = await container.get(mod);
        // Initialize the module
        const Module = factory();
        if (isSSR()) {
            // serialize preloaded features
            PRELOAD_FEATURES[`${scope}-${mod}`] = [scope, mod];
            injectMetadata();
        }
        else if (hydration) {
            cacheModule(scope, mod, await Module);
        }
        return Module;
    };
}
function injectMetadata() {
    if (isSSR()) {
        const script = document.createElement('script');
        script.innerText = `window.__PRELOAD_FEATURES__ = ${JSON.stringify(PRELOAD_FEATURES)}`;
        script.dataset['featureapps'] = '1';
        // remote existing
        const existing = document.querySelector('script[data-featureapps="1"]');
        if (existing) {
            document.head.removeChild(existing);
        }
        // append to head
        document.head.appendChild(script);
    }
}
